/** Internal helper imports here ... */
const Masonry = require('masonry-layout');

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.layoutContainer = document.getElementsByClassName('post__image-grid')[0];
  };

  const renderLayout = () => {
    new Masonry( DOM.layoutContainer, {
      // options...
      itemSelector: '.post__image-grid__item',
      gutter: '.post__image-grid__gutter',
      percentPosition: true,
      masonry: {
        columnWidth: '.post__image-grid__sizer'
      }
    });
  };

  const eventListeners = () => {
    window.addEventListener('load', renderLayout);
  };

  const init = () => {
    cacheDOM();

    if (DOM.layoutContainer) {
      eventListeners();
    }
  };

  return {
    init
  };
})();
